import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class TncLicenseStatus extends AbstractModel {
  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  name: string;
}
